import {DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {CouponTypeObject, StoredUser} from "./SanPellegrino";
import {ApiPathsService} from "../../../app/api-paths.service";


function campoCustom(nome: string, valore:((coupon,parent?)=>string )| string) {
  return {
    nome: nome, oggetti: ["prezzo"], type: 'html', func: (coupon, parent?) => [typeof valore == "string" ? valore : valore(coupon,parent)]
  }
}

function Headers()
{
  return [
    CampoAggiuntivo.InputField("Data di Inserimento", "data", "date", "", {modificabile: false}),
    campoCustom("Descrizione", (movimentazione) => `${movimentazione.prodotto} - ${CouponTypeObject({posizione: movimentazione.tipologia})?.label}`),
    campoCustom("Assegnata", (movimentazione) => movimentazione.assegnati),
    campoCustom("Effettuata Da", (movimentazione) => StoredUser()?.fullName),
  ]
}

function ExportMovimentazioni(x, api:ApiPathsService){

    api.ClassicPost('/prodotti/coupon/movimentazioni/giorno',{data:x.data, prodotto: x.id, tipo: x.tipologia}).subscribe(movimentazioni => {

    const Headers = HeaderDettaglioMov()?.filter(header => header.printable != false);
    const normalizedData: any[] = movimentazioni.data.map(element => {
      var newElement = {};
      Headers.forEach(header => {
        newElement[header.nome] = DynamicCrudService.getCampoAsString(header, element, {}) ?? '';
      })
      return newElement;
    })
    DynamicCrudService.exportToExcel(normalizedData, Headers, `Export Assegnazioni ${x.prodotto} - ${CouponTypeObject({posizione: x.tipologia})?.label} del ${x.data}`);

    })

}
function HeaderDettaglioMov(){
  return [
    CampoAggiuntivo.InputField("SOM","persona",'text','',{modificabile:false}),
    CampoAggiuntivo.InputField("QTA (PRE ASSEGNAZIONE)","QPreAss",'text','',{modificabile:false}),
    CampoAggiuntivo.InputField("QTA (MOVIMENTATA)","QMov",'text','',{modificabile:false}),
    CampoAggiuntivo.InputField("QTA (POST ASSEGNAZIONE)","QPostAss",'text','',{modificabile:false}),
  ]
}

export function ReportAssegnazioni(): OggettoConfig {
  var OBJ: OggettoConfig = {
    Id: "report-assegnazioni",
    fullListRoute: "/prodotti/coupon/movimentazioni",
    RestRoute: "/prodotti/coupon",
    ListDefaultFilter: {page:1},
    ListResponseHasData:true,
    HasGet:false,
    Label:"Assegnazioni",

    MenuItems: [
      {
        path: "/shared/dynamiclist/report-assegnazioni",
        title: "Storico Assegnazioni",
        icon: "fas fa-history",
        class: "",
        capacita: [],
        ruoliOperativi:["S", "SA", "DM"]
      },
    ],
    // Filters:[
    //   CampoAggiuntivo.InputField("Codice Coupon", "prodotto", "text", "col-lg-9", ),
    // ],

    Headers: Headers(),
    PrintHeaders: Headers().map(x=>({...x, printable:true})),
    DisableEdit: true,
    AzioniLista: [
      {
        noGet:true,
        nome: 'Dettaglio',
        close: false,
        icon: 'fa-regular fa-eye text-info ',
        class: ' btn ',
        single: true,
        labelClass: 'text-info ',
        type: 'edit',
        tooltip: "Vedi il dettaglio",
        asyncItem: (x, service: DynamicCrudService, callback) => {
          service.api.ClassicPost('/prodotti/coupon/movimentazioni/giorno',{data:x.data, prodotto: x.id, tipo: x.tipologia}).subscribe(movimentazioni => {
            callback({...x, mov: movimentazioni.data})
          })

        },
        campi:[
          CampoAggiuntivo.TableField("", HeaderDettaglioMov(),'mov', true)
        ]

      },
      {
        noGet:true,
        nome:'Export',
        icon: 'fa-solid fa-print text-info',
        class: 'btn',
        single: true,
        labelClass: 'text-info',
        type: 'func',
        tooltip: "Esporta",
        func: ExportMovimentazioni
      }
    ]
  }


  return OBJ;
}


